import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import { useMobile } from "../../../hooks/useMobile";

function NtMobileStatsSection(props) {
  const isMobile = useMobile();
  const renderStats = (stat, type) => {
    return (
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        <NtText style={{ color: "white", fontSize: 28, fontWeight: "600" }}>
          {stat}
        </NtText>
        <NtText
          style={{
            marginTop: 6,
            color: "white",
            fontWeight: "300",
            fontSize: 12,
          }}
        >
          {type}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      {/* <View style={{ flexDirection: "row" }}>
        {renderStats("120M+", "Downloads")}
        {renderStats("4.5+", "Rating")}
        {renderStats("20M+", "Active users")}
        {renderStats("40+", "Country's")}
      </View> */}

      <View
        style={{ flexDirection: isMobile ? "column" : "row", marginTop: 60 }}
      >
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left" }}>
            IT DOESN'T GET BETTER{"\n"}THAN THIS.
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 8 }}>
            The Talk App allows you to make calls via your mobile phone's Wi-Fi
            / LTE / 3G / 4G connection without roaming charges. It is available
            for iOS and Android mobile devices.
          </NtSectionDescription>
        </View>
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <Image
            style={[
              {
                width: 300,
                height: 350,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/phone-blue-background.png")}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 30,
    paddingBottom: 60,
  },
});

export default NtMobileStatsSection;
